import MaintenanceNotification from './MaintenanceNotification';

export default MaintenanceNotification;



// WEBPACK FOOTER //
// ./src/client/Components/MaintenanceNotification/index.js